import { useSnackbarStore } from '~/store/snackbar';

export const $notifier = {
  showMessage({ content = '', color = 'success' }) {
    const { showMessage } = useSnackbarStore();
    showMessage({ content, color });
  },

  showError({ content = 'Error' }) {
    const { showMessage } = useSnackbarStore();
    showMessage({ content, color: 'error' });
  },
};
